import { Injectable, inject } from '@angular/core';

import { BasicObject, Scoring } from '@bytel/bytel-sales';

import { ObjectOfString } from '@base/common/models/services.interface';
import { Oauth2ResourcesService } from '@base/common/oauth2/oauth2-resources.service';

import { Observable } from 'rxjs';

import {
    BankingVerificationApiPayload,
    BankingVerificationAskingResponse,
    GetBankingVerificationAskingResponse,
} from '../interfaces/api/open-banking.api.interface';
import { ScoringV3API } from '../interfaces/scoring-api.interface';

@Injectable({
    providedIn: 'root',
})
export class PaymentRepository {
    private oauth2Resource: Oauth2ResourcesService = inject(Oauth2ResourcesService);

    /**
     * Check IBAN validity
     * @param params Iban to check
     * @param cartId Current cart id
     * @param quoteId quote id
     * @returns Return BasicObject
     */
    public checkIban(params: ObjectOfString, cartId: number, quoteId: number): Observable<BasicObject> {
        return this.oauth2Resource
            .ventes()
            .panier(cartId)
            .parcours(quoteId)
            .iban()
            .setLocalService()
            .useSalesApi()
            .post(params);
    }

    /**
     *
     * @param idPu current user id
     * @param cartId current cart id
     * @returns Scoring details
     */
    public getScoring(idPu: string, cartId: number): Observable<Scoring> {
        return this.oauth2Resource
            .ventes()
            .scoring()
            .setLocalService()
            .useSalesApi()
            .setParams({ idPU: idPu, cartId })
            .get();
    }

    public getScoringV3(cartId: number, hasCreditIntention: boolean): Observable<ScoringV3API> {
        return this.oauth2Resource
            .scoringV3()
            .setLocalService()
            .useSalesApi()
            .post({
                enregistrementCommande: false,
                intentionFinancementCredit: hasCreditIntention,
                objetControle: { id: `${cartId}`, type: 'PANIER' },
            });
    }

    public askForBankingVerification(
        payload: BankingVerificationApiPayload,
    ): Observable<BankingVerificationAskingResponse> {
        return this.oauth2Resource.openBankingVerification().setLocalService().useSalesApi().post(payload);
    }

    public getBankingVerification(idPu: string): Observable<GetBankingVerificationAskingResponse> {
        return this.oauth2Resource.openBankingCheckVerification(idPu).setLocalService().useSalesApi().get();
    }
}
